/* eslint-disable indent */
import React, { Fragment, useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
// import Image from "react-bootstrap/Image";
// import { LazyLoadImage } from "react-lazy-load-image-component";

import Starter from "../../component/Starter";
import Card from "../../component/card/Card";
import SelectInput2 from "../../component/input/SelectInput2";
import {
  isSuperAdmin,
  locationRender,
  renderAccessLocation2,
  renderLocationFunction
} from "../../constant/helper/helper";
import TextInput2 from "../../component/input/TextInput2";
import Button from "../../component/button/Button";
import { userActions } from "../../redux/actions";
import isEmpty from "../../validation/isEmpty";

const initialState = {
  Filter: "",
  workerId: "0",
  locationId: "",
  activeStatus: true
};

const UserPhotos = () => {
  const loginType = localStorage.loginType;
  const componentRef = useRef();
  const dispatch = useDispatch();
  const [isDynamic, setIsDynamic] = useState("STATIC");
  const [values, setValues] = useState(initialState);
  const [userImageList, setUserImageList] = useState([]);

  const { currentUser } = useSelector((state) => state.auth);
  const { locations } = useSelector((state) => state.location);
  const { allUserImages, nextPage, previousPage } = useSelector(
    (state) => state.user
  );

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value
    });
  };

  useEffect(() => {
    if (!isEmpty(allUserImages)) {
      setUserImageList(allUserImages);
    } else {
      setUserImageList([]);
    }
  }, [allUserImages]);

  const commonDispatch = () => {
    dispatch(userActions.setUserLoading(true));
    dispatch(userActions.clearUserErrors());
    dispatch(userActions.clearUserResult());
    // dispatch(userActions.unmountAllUsersData());
  };

  const getUserByWorkerId = (e) => {
    e.preventDefault();
    commonDispatch(true);
    dispatch(
      userActions.getAllUserImages(
        isDynamic,
        values,
        loginType,
        1,
        500
      )
    );
  };

  const nextButton = (e) => {
    e.preventDefault();
    commonDispatch(true);
    dispatch(
      userActions.getAllUserImages(
        isDynamic,
        values,
        loginType,
        nextPage.page,
        nextPage.limit
      )
    );
  };
  const previousButton = (e) => {
    e.preventDefault();
    commonDispatch(true);
    dispatch(
      userActions.getAllUserImages(
        isDynamic,
        values,
        loginType,
        previousPage.page,
        previousPage.limit
      )
    );
  };

  const showUserList = (userList) => {
    return userList.map((userImageData, imageIndex) => (
      <tr key={imageIndex}>
        <td className="text-center">
          <span>{imageIndex + 1}</span>
        </td>
        <td className="text-center">
          <span>{userImageData.workerId}</span>
        </td>
        <td className="text-center">
          <span>{userImageData.locationName}</span>
        </td>
        <td className="text-center">
          <span>{userImageData.locationCode}</span>
        </td>
        <td className="text-center">
          {userImageData.registerFaceImages.map(
            (imageList, imgIndex) => (
              // <LazyLoadImage
              // alt={image.alt}
              // height={image.height}
              // src={image.src} // use normal <img> attributes as props
              // width={image.width} />
              <a
                href={imageList}
                target="_blank"
                rel="noopener noreferrer"
                key={imgIndex}
              >
                Image No.{imgIndex + 1},
                {/* <LazyLoadImage
                  src={imageList}
                  width={50}
                  height={50}
                  alt="Image Alt"
                  className="ml-1 mr-1"
                /> */}
                {/* <Image
                thumbnail
                src={imageList}
                style={{
                  height: "50px",
                  width: "50px"
                }}
              /> */}
              </a>
            )
          )}
        </td>
      </tr>
    ));
  };

  return (
    <Starter
      topBarTitle="All Images"
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">Register Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">Registration</a>
          </li>
          <li className="breadcrumb-item active">All Images</li>
        </Fragment>
      }
    >
      <Card>
        <div className="row">
          <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3">
            <SelectInput2
              data-tip
              name="isDynamic"
              isLabeled={true}
              value={isDynamic}
              data-for="isDynamic"
              icon="mdi mdi-playlist-check"
              label="Select Search Data Type"
              placeholder="Select Search Data Type"
              onChange={(e) => setIsDynamic(e.target.value)}
            >
              <option value="STATIC">Static</option>
              <option value="DYNAMIC">Dynamic</option>
            </SelectInput2>
          </div>
          <div className="col-lg-3 col-md-3 col-sm-12">
            <SelectInput2
              data-tip
              isLabeled={true}
              name="locationId"
              onChange={handleInputChange}
              data-for="locationId"
              label="Select Location"
              value={values.locationId}
              placeholder="Select Location"
              icon="mdi mdi-map-marker-radius"
            >
              {isSuperAdmin(currentUser)
                ? renderLocationFunction(locations)
                : renderAccessLocation2(
                    locationRender(currentUser, false)
                  )}
            </SelectInput2>
          </div>
          {isDynamic === "DYNAMIC" && (
            <div className="col-lg-3 col-md-3 col-sm-12">
              <TextInput2
                data-tip
                type="text"
                name="workerId"
                onChange={handleInputChange}
                data-for="workerId"
                value={values.workerId}
                icon="mdi mdi-table-search"
                placeholder="Search E-Code..."
              />
            </div>
          )}
          <div className="col-lg-2 col-md-2 col-sm-12">
            <Button
              data-tip
              title="Get"
              type="button"
              data-for="getButton"
              isBackgroundColor={false}
              onClick={getUserByWorkerId}
              icon="mdi mdi-database-plus mr-2"
              className="btn text-white btn-block btn-primary float-right"
            />
          </div>
          <div className="col-lg-2 col-md-2 col-sm-12">
            <Button
              data-tip
              title="Previous"
              type="button"
              data-for="previousButton"
              isBackgroundColor={false}
              onClick={previousButton}
              icon="mdi mdi-arrow-left mr-2"
              className="btn text-white btn-block btn-dark float-right"
              disabled={previousPage === null}
            />
          </div>
          <div className="col-lg-2 col-md-2 col-sm-12">
            <Button
              data-tip
              title="Next"
              type="button"
              data-for="nextButton"
              isBackgroundColor={false}
              onClick={nextButton}
              icon="mdi mdi-arrow-right mr-2"
              className="btn text-white btn-block btn-warning float-right"
            />
          </div>
        </div>
        <div
          className="table-responsive"
          style={{ height: "700px", overflow: "auto" }}
          ref={componentRef}
        >
          <table
            className="table table-bordered table-centered mb-0 table-hover w-100 dt-responsive nowrap"
            id="products-datatable"
          >
            <thead className="thead-light">
              <tr>
                <th style={{ width: "20px" }}>#</th>

                <th className="text-center">E-Code</th>
                <th className="text-center">Location Name</th>
                <th className="text-center">Location Code</th>
                <th className="text-center">Image List</th>

                <th className="text-center">Actions</th>
              </tr>
            </thead>
            <tbody>{showUserList(userImageList)}</tbody>
          </table>
        </div>
        <div className="row mt-3">
          <div className="col-sm-1"></div>
          <div className="col-sm-4"></div>
          <div className="col-2">
            <ReactHTMLTableToExcel
              data-tip
              sheet="Sheet"
              data-for="exportToExcel"
              buttonText="Export excel"
              table="products-datatable"
              className="btn btn-dark btn-block"
              filename={`${values.locationId}}`}
            />
          </div>
          <div className="col-sm-1"></div>
          <div className="col-sm-4"></div>
        </div>
      </Card>
    </Starter>
  );
};

export default UserPhotos;
